
import React from 'react';
import PageContainer from '@/components/layout/PageContainer';
import BackButton from '@/components/ui/back-button';
import RequestCompanyForm from '@/components/company-request/RequestCompanyForm';

const RequestCompany = () => {
  return (
    <PageContainer>
      <BackButton className="mb-6" />
      <RequestCompanyForm />
    </PageContainer>
  );
};

export default RequestCompany;
